import React from "react";
import {useCurrentUserPrivileges} from "../platform/hooks/PlatformHooks";

/**
 * Pay attention to duplication with backend OptiselPrivilegeProvider
 */
export type OptiselPrivilege =
    "USER_ACCOUNT_MANAGEMENT" |
    "AUTHORIZATION_MANAGEMENT" |
    "IMPELLER_SIMULATION" |
    "IMPELLER_ASSEMBLY" |
    "SELECTION_HISTORY" |
    "IMPELLER_DATA_ADMINISTRATION" |
    "DW_BOM_DOWNLOAD" |
    "UNTRIAGED_SELECTION" |
    "PERM_AUTHENTICATED_USER" |
    "PERM_USER_ACCESS_MANAGEMENT" |
    "PERM_DEVELOPMENT_TOOLS" |
    "PERM_SELECTION" |
    "PERM_SELECTION_CALCULATION_LOGS" |
    "PERM_SELECTION_UNTRIAGED_SELECTION" |
    "PERM_SELECTION_TRIAGE_DETAILED_PARAMETERS" |
    "PERM_SELECTION_EXTENDED_SELECTION" |
    "PERM_SELECTION_FAN_ONLY_PRESSURE_SELECTION" |
    "PERM_SELECTION_FAILED_ASSEMBLY_SELECTION" |
    "PERM_FLOW_SIMULATION" |
    "PERM_DW_AND_BOM" |
    "PERM_FAN_ASSEMBLY" |
    "PERM_ENGINEERING_OVERRIDES" |
    "PERM_HISTORY_AND_ISSUES" |
    "PERM_HISTORY_AND_ISSUES_MANAGEMENT" |
    "PERM_MULTI_FAN_ACOUSTIC" |
    "PERM_DATA_ADMINISTRATION";

export function useHasCurrentUserPrivilege(privilege: OptiselPrivilege): boolean | "loading" {
    const privileges: string[] | "loading" = useCurrentUserPrivileges();

    if (privileges === "loading") {
        return "loading";
    }
    return privileges.includes(privilege);
}

export function Protected(props: { privilege: OptiselPrivilege, children: React.ReactNode }): JSX.Element {
    const privileges: string[] | "loading" = useCurrentUserPrivileges();

    if (privileges === "loading") {
        return <></>;
    }
    if (privileges.includes(props.privilege)) {
        return <>{props.children}</>;
    } else {
        return <span className={"permission-disallowed"}></span>;
    }
}

export function useHasCurrentUserAnyPrivilege(privileges: OptiselPrivilege[]): boolean | "loading" {
    const userPrivileges: string[] | "loading" = useCurrentUserPrivileges();

    if (userPrivileges === "loading") {
        return "loading";
    }
    return privileges.some(privilege => userPrivileges.includes(privilege));
}

export function ProtectedByOneOf(props: { privileges: OptiselPrivilege[], children: React.ReactNode }): JSX.Element {
    const userPrivileges: string[] | "loading" = useCurrentUserPrivileges();

    if (userPrivileges === "loading") {
        return <></>;
    }

    const hasAnyPrivilege = props.privileges.some(privilege =>
        userPrivileges.includes(privilege)
    );

    if (hasAnyPrivilege) {
        return <>{props.children}</>;
    } else {
        return <span className={"permission-disallowed"}></span>;
    }
}